export default __webpack_public_path__ + "static/media/what-is-your-name-2.0029db65.png";